import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header';
import CampaignFooter from '../components/CampaignSummary/CampaignFooter';
import CampaignBarChart from '../components/CampaignSummary/CampaignBarChart';
import CampaignDonutChart from '../components/CampaignSummary/CampaignDonutChart';
import CampaignIncomeChart from '../components/CampaignSummary/CampaignIncomeChart';
import CampaignGenderChart from '../components/CampaignSummary/CampaignGenderChart';
import CampaignOccupationChart from '../components/CampaignSummary/CampaignOccupationChart';
import ResponsiveImg from '../images/Responsive design_4.png';
import CustomerImg from '../images/Global business_7.png';
import TouchableImg from '../images/Touchscreen tablet.png';

import PublicModalWrappers from '../components/public/PublicModalWrappers';
import MoreInfo from '../components/CampaignSummary/MoreInfo';

const CampaignReport = () => {
  const [modalIsOpen, closeModal] = useState(false);

  return (
    <div>
      <Header />
      <div style={{ position: 'relative' }}>
        <div
          className="CampaignSummary_top-background"
          style={{ minHeight: '900px' }}
        />
        <div className="CampaignSummary_content-background" />

        <div className="CampaignSummary_container">
          <div
            className="CampaignSummary_container_top-area"
            style={{ flexDirection: 'column' }}
          >
            <div className="CampaignReport_title-area">
              <div className="CampaignReport_title-1">
                <div>Channel 7</div>
                <h3>Campaign Audience Summary</h3>
              </div>
              <div className="CampaignReport_title-2">
                <div className="CampaignReport_label">Account Manager</div>
                <div className="CampaignReport_value">Jackie Collins</div>
              </div>
            </div>
            <div className="CampaignReport_detail-area">
              <div className="CampaignReport_detail-blocks">
                <div className="CampaignReport_label">Campaign</div>
                <div className="CampaignReport_value">Monoply</div>
              </div>
              <div className="CampaignReport_detail-blocks">
                <div className="CampaignReport_label">Advertiser</div>
                <div className="CampaignReport_value">McDonalds</div>
              </div>
              <div className="CampaignReport_detail-blocks">
                <div className="CampaignReport_label">Agency</div>
                <div className="CampaignReport_value">OMD</div>
              </div>
              <div className="CampaignReport_detail-blocks">
                <div className="CampaignReport_label">Campaign Start Date</div>
                <div className="CampaignReport_value">02/01/2021</div>
              </div>
              <div className="CampaignReport_detail-blocks">
                <div className="CampaignReport_label">Campaign End Date</div>
                <div className="CampaignReport_value">01/02/2021</div>
              </div>
              <div className="CampaignReport_detail-blocks">
                <div className="CampaignReport_label">
                  Geographical targeting
                </div>
                <div className="CampaignReport_value">NSW, VIC, SA</div>
              </div>
            </div>
            <div className="CampaignReport_summary-area">
              <div className="CampaignReport_summary-block">
                <img src={ResponsiveImg} />
                <h3>100,000</h3>
                <span>Impressions</span>
              </div>
              <div className="CampaignReport_summary-block">
                <img src={CustomerImg} />
                <h3>23,456</h3>
                <span>Customers</span>
              </div>
              <div className="CampaignReport_summary-block">
                <img src={TouchableImg} />
                <h3>8%</h3>
                <span>CTR</span>
              </div>
            </div>
            <div className="CampaignReport_statement">
              The report uses all [Media Owners]'s customers as the baseline
              when indexing
            </div>
          </div>
          <div
            className="CampaignSummary_container_full-content-area"
            style={{ padding: '2rem', position: 'relative' }}
          >
            <CampaignBarChart
              title="Brand Affinity"
              data={[...Array(10).keys()].map(i => i + 1)}
              closeModal={closeModal}
            />
          </div>
          <div
            className="CampaignSummary_container_full-content-area"
            style={{ padding: '2rem', position: 'relative' }}
          >
            <CampaignBarChart
              title="Industry Category Affinity"
              data={[...Array(5).keys()].map(i => i + 1)}
              closeModal={closeModal}
            />
          </div>

          <div className="CampaignSummary_container_half-content-area">
            <CampaignDonutChart
              title="Age"
              data={[
                { name: 'Group A', value: 0.4, range: '25-54' },
                { name: 'Group B', value: 0.3, range: '15-24' },
                { name: 'Group C', value: 0.3, range: '40-54' },
                { name: 'Group D', value: 0.2, range: '55-64' },
                { name: 'Group E', value: 0.1, range: '64-85' },
              ]}
              circleTitle={35}
              circleText="Average age"
              closeModal={closeModal}
            />
          </div>
          <div className="CampaignSummary_container_half-content-area">
            <CampaignGenderChart
            closeModal={closeModal}
            />
          </div>
          <div className="CampaignSummary_container_half-content-area">
            <CampaignIncomeChart
            title="Income"
            closeModal={closeModal}
            />
          </div>
          <div className="CampaignSummary_container_half-content-area">
            <CampaignIncomeChart
            title="Mortgage / Rent"
            closeModal={closeModal}
            />
          </div>
          <div className="CampaignSummary_container_half-content-area">
            <CampaignDonutChart
              title="Education"
              data={[
                { name: 'Group A', value: 0.4, range: 'No qualification' },
                { name: 'Group B', value: 0.3, range: 'Secondary' },
                { name: 'Group C', value: 0.3, range: 'Tertiary' },
                { name: 'Group D', value: 0.2, range: 'Postgraduate' },
              ]}
              circleTitle="Secondary"
              circleText="Average education"
              closeModal={closeModal}
            />
          </div>
          <div className="CampaignSummary_container_half-content-area">
            <CampaignOccupationChart closeModal={closeModal} />
          </div>
        </div>
        <CampaignFooter />

        <PublicModalWrappers
          isOpen={modalIsOpen}
          close={() => closeModal(!modalIsOpen)}
          width="50%"
        >
          <MoreInfo closeModal={closeModal} />
        </PublicModalWrappers>
      </div>
    </div>
  );
};

export default CampaignReport;
